import { SuperAdminConstants } from '../../../_constants';

const initialState = { delAssignMetricLoading: true, data: '', error: false };

export function delAssignMetricReducer(state = initialState, action) {
    
    switch (action.type) {
        case SuperAdminConstants.REQUEST_DELETE_ASSIGN_ASSESSOR:
            return {
                delAssignMetricLoading: true,
                data: '',
                error: false
            };
        case SuperAdminConstants.RECEIVE_DELETE_ASSIGN_ASSESSOR:
            return {
                delAssignMetricLoading: false,
                data: action,
                error: false
            };
        case SuperAdminConstants.DELETE_ASSIGN_ASSESSOR_ERROR:
            return {
                delAssignMetricLoading: false,
                data: '',
                error: true
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/SuperAdmin/AssignAssessor/removeAssignAssessorGroup.js